/**
 * `cn` — Tailwind className combiner used by every shadcn/ui component.
 * `clsx` joins truthy class strings, `tailwind-merge` deduplicates conflicts.
 */

import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
